export function getElementTop(element) {
    let top = 0;
    while (element && 'offsetParent' in element) {
        top += element.offsetTop;
        element = element.offsetParent;
    }
    return top;
}
